<app-sidebar [isOpen]="isOpen" (close)="onClose()">

  <div class="cart-container">

    <div class="header">
      <span class="guid"> <img src="assets/svg/icon-shop-white.svg" alt="ruler">Tu carrito</span>
      <button class="close" (click)="onClose()">✕</button>
    </div>

    <div class="count" *ngIf="items.length > 0">
      ({{ items.length }} producto{{ items.length > 1 ? 's' : '' }})
    </div>

    <div class="cart-list" *ngIf="items.length > 0">
      <div class="item-wrapper" *ngFor="let item of items">
        <div class="item">
          <div class="img-box">
            <img class="product-img" [src]="item.image" />
          </div>
          <div class="info">
            <h4>{{ item.name }}
              <ng-container *ngFor="let attr of item.selectAttributes">
                | {{ attr.value }}
              </ng-container>
            </h4>
            <span class="category" *ngIf="item.belowAttributes?.length">
              <ng-container *ngFor="let attr of item.belowAttributes; let last = last">
                {{ attr.value }}<span *ngIf="!last"> | </span>
              </ng-container>
            </span>

            <div class="price-row">
              <div class="price-info">
                <span class="price fw-bold">S/ {{ item.price }}</span>
                <span class="old" *ngIf="item.oldPrice > item.price">S/ {{ item.oldPrice }}</span>
              </div>

              <!-- contador: visible en desktop, oculto en mobile via CSS -->
              <div class="actions">
                <button (click)="decrease(item)">−</button>
                <span>{{ item.qty }}</span>
                <button (click)="increase(item)">+</button>
                <button class="delete" (click)="remove(item)">
                  <img src="assets/svg/icon-trash.svg">
                </button>
              </div>
            </div>

            <div class="size-qty-row" *ngIf="item.numberAttributes?.length">
              <p class="size" *ngFor="let attr of item.numberAttributes">
                {{ attr.name }}: {{ attr.value }}
              </p>
            </div>

            <!-- contador: visible solo en mobile (debajo de la talla) -->
            <div class="actions-mobile">
              <button (click)="decrease(item)">−</button>
              <span>{{ item.qty }}</span>
              <button (click)="increase(item)">+</button>
              <button class="delete" (click)="remove(item)">
                <img src="assets/svg/icon-trash.svg">
              </button>
            </div>

          </div>
        </div>

        <div class="personalization" *ngIf="item.customization">
          <div class="pers-header">
            <span class="pers-label">Personalización:</span>
            <button class="pers-edit" (click)="editCustomization(item)">Editar</button>
          </div>
          <div class="pers-details">
            <span class="pers-item" *ngFor="let part of item.customization.split(' | ')">{{ part }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="empty-cart" *ngIf="items.length === 0">
      <p>Tu carrito está vacío</p>
    </div>

    <ng-container *ngIf="items.length > 0">
      <!-- Código de descuento -->
      <div class="discount-section">
        <div class="discount-toggle" (click)="showDiscountInput = !showDiscountInput">
          <img src="assets/svg/icon-discount.svg" alt="" style="width:16px;height:16px;">
          <span>Usar un código de descuento</span>
        </div>
        <div class="discount-input-row" *ngIf="showDiscountInput">
          <input type="text" [(ngModel)]="discountCode" placeholder="Ingrese código" [disabled]="!!appliedDiscount" />
          <button *ngIf="!appliedDiscount" (click)="validateDiscount()" [disabled]="!discountCode.trim()">Validar</button>
          <button *ngIf="appliedDiscount" class="btn-remove" (click)="removeDiscount()">✕</button>
        </div>
        <p class="discount-applied" *ngIf="appliedDiscount">✓ Código {{ appliedDiscount.code }} aplicado (-{{ appliedDiscount.percentage }}%)</p>
        <p class="discount-error" *ngIf="discountError">{{ discountError }}</p>
      </div>

      <div class="summary">
        <div class="box">
          <div class="row">
            <span class="sub">Subtotal</span>
            <span class="price">S/ {{ subtotal.toFixed(2) }}</span>
          </div>
          <div class="row">
            <span class="sub">Descuentos</span>
            <span class="price">S/ {{ discount.toFixed(2) }}</span>
          </div>
          <div class="row">
            <span class="sub">Entrega</span>
            <span class="price">S/ 0.00</span>
          </div>
          <div class="row total">
            <span class="sub fw-bold">Total</span>
            <span class="price">S/ {{ total.toFixed(2) }}</span>
          </div>
        </div>
      </div>

      <button class="checkout" (click)="checkout()" [disabled]="isProcessing">
        {{ isProcessing ? 'Procesando...' : 'Finalizar Compra' }}
      </button>
      <p class="checkout-error" *ngIf="checkoutError">{{ checkoutError }}</p>
    </ng-container>

  </div>

</app-sidebar>
